import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useContext } from 'react';
import colorContext from '../../Context/colorContext';

interface Props {
  open: boolean;
  onClose: () => void;
  onLogin: () => void;
}

export default function ModalNotAuth({ open, onClose, onLogin }: Props): JSX.Element {
  const { colors } = useContext(colorContext);
  const useStyles = makeStyles({
    root: {
      backgroundColor: colors.serviceCardBackgroundColor,
      color: colors.textBody,
    },
    title: {
      color: colors.textBody,
      backgroundColor: colors.serviceCardBackgroundColor,
    },
    content: {
      color: colors.textBody,
    },
    actions: {
      backgroundColor: colors.serviceCardBackgroundColor,
    },
    buttonCloser: {
      color: colors.accentColor,
      textTransform: 'none',
    },
    buttonLogin: {
      textTransform: 'none',
      color: colors.accentColor,
      border: `1px solid ${colors.accentColor}`,
    },
  });
  const classes = useStyles();

  return (
    <Dialog open={open} fullWidth maxWidth='sm'>
      <DialogTitle className={classes.title}>
        Login necessário
      </DialogTitle>
      <DialogContent classes={{ root: classes.root }}>
        <DialogContentText className={classes.content}>
          Para ter acesso ao serviço, é preciso fazer o login no Portal Único.
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button className={classes.buttonCloser} onClick={onClose}>
          Fechar
        </Button>
        <Button className={classes.buttonLogin} onClick={onLogin}>
          Fazer login
        </Button>
      </DialogActions>
    </Dialog>
  );
}
